/**
 * A table that may be wider than the screen. On a phone it scrolls sideways inside this region,
 * which is focusable and named so a keyboard can reach and scroll it and a screen reader says
 * what it holds.
 */
export function TableScroll({ label, children, className = "", style }: {
  label: string; children: React.ReactNode; className?: string; style?: React.CSSProperties;
}) {
  return (
    <div role="region" aria-label={label} tabIndex={0} className={`table-region ${className}`.trim()} style={style}>
      {children}
    </div>
  );
}
